import { LinkedIn } from "@mui/icons-material";
import {
  zero,
  aIbuiltin,
  recurring,
  reporting,
  people,
  easy,
  security,
  virtualcards,
  facebook,
  gmail,
  twitter,
  instagram,
  antiFraud,
  bill,
  card,
  emptyWallet,
  shopping,
  DigitalWallet,
  airplane,
  ticket,
  receipt,
  gift,
  vector01,
  Link,
  note,
  linkedIn,
} from "../../public/assets";

interface FooterLink {
  name: string;
  link: string;
}

interface FooterSection {
  title: string;
  links: FooterLink[];
}
interface NavIconSection {
  id: string;
  name: string;
  link: string;
  icon: string;
}

export type NavLink = {
  id: string;
  title: string;
  url?: string;
};

type ServiceItem = {
  id: string;
  content: string;
  title: string;
  img: string;
};

type Language = {
  id: string;
  country_name: string;
  country_code: string;
};

type ProductDropDownData = {
  id: string;
  label: string;
  icon: string;
};
export const languages: Language[] = [
  {
    id: "es",
    country_name: "Spanish",
    country_code: "es",
  },
  {
    id: "en",
    country_name: "English",
    country_code: "gb",
  },
];

export const navLinks: NavLink[] = [
  // {
  //   id: "Products",
  //   title: "Products",
  // },
  // {
  //   id: "business-page",
  //   title: "Business",
  //   url: "business",
  // },
  // {
  //   id: "Personal",
  //   title: "Personal",
  // },
  // {
  //   id: "Pricing",
  //   title: "Pricing",
  //   // url: "/",
  // },
  // {
  //   id: "Support",
  //   title: "Support",
  //   // url: "/",
  // },
];

export const service: ServiceItem[] = [
  {
    id: "service-1",
    content: "No fees required to create an account or use sanbox environment.",
    title: "Zero Setup Fees",
    img: "/assets/icons/zero.png",
  },
  {
    id: "service-2",
    content:
      "Connect to FiPay quickly using our tech documentation to guide your integration.",
    title: "Seamless Integration",
    img: "/assets/icons/easy.png",
  },
  {
    id: "service-3",
    content: "Ensure each transaction is secure and lower potential fraud.",
    title: "Secure Transactions",
    img: "/assets/icons/security.png",
  },
  {
    id: "service-4",
    content: "Accept pay with bank transactions for recurring merchants.",
    title: "Recurring Payments",
    img: "/assets/icons/recurring.png",
  },
  {
    id: "service-5",
    content: "Attract merchants with a payment method that rewards customers.",
    title: "Consumer Incentives",
    img: "/assets/icons/people.png",
  },
  {
    id: "service-6",
    content:
      "Receive quicker settlement from banks so merchants can access their funds faster.",
    title: "Fast Settlement",
    img: "/assets/icons/virtualcards.png",
  },
  {
    id: "service-7",
    content: "Use our universal smart token system to connect securely.",
    title: "AI built-in",
    img: "/assets/icons/aIbuiltin.png",
  },
  {
    id: "service-8",
    content: "Receive reports that share important transaction details.",
    title: "Reporting & Receipts",
    img: "/assets/icons/reporting.png",
  },
  // {
  //   id: "service-9",
  //   content:
  //     "See all your merchant activities in an easy to read report with receipt detials, to help make better decisions.",
  //   title: "Reporting & Receipts",
  //   img: reporting,
  // },
];

export const footerLinks: FooterSection[] = [
  // {
  //   title: "Company",
  //   links: [
  //     {
  //       name: "About Us",
  //       link: "/business",
  //     },
  //     {
  //       name: "FAQs",
  //       link: "/business",
  //     },
  //     {
  //       name: "Blogs",
  //       link: "",
  //     },
  //   ],
  // },
  // {
  //   title: "Products",
  //   links: [
  //     {
  //       name: "Personal",
  //       link: "/",
  //     },
  //     {
  //       name: "Business",
  //       link: "/business",
  //     },
  //     {
  //       name: "Pricing",
  //       link: "/",
  //     },
  //   ],
  // },
  // {
  //   title: "Legal",
  //   links: [
  //     {
  //       name: "Terms & Conditions",
  //       link: "/terms-and-condition",
  //     },
  //     {
  //       name: "Privacy Policy",
  //       link: "/privacy-policy",
  //     },
  //     {
  //       name: "Security",
  //       link: "/",
  //     },
  //   ],
  // },
  // {
  //   title: "Support",
  //   links: [
  //     {
  //       name: "Contact Us",
  //       link: "/business",
  //     },
  //     {
  //       name: "Help Center",
  //       link: "/",
  //     },
  //   ],
  // },
];

export const socialMedia = [
  {
    id: "social-media-1",
    icon: "/assets/icons/instagram.svg",
    // link: "https://www.instagram.com/",
  },
  {
    id: "social-media-2",
    icon: "/assets/icons/facebook.svg",
    link: "https://www.facebook.com/profile.php?id=61555685300006",
  },
  {
    id: "social-media-3",
    icon: "/assets/icons/twitter.svg",
    link: "https://twitter.com/FiPay_io",
  },
  {
    id: "social-media-4",
    icon: "/assets/icons/email.svg",
    link: "mailto:contact@fipay.io",
  },
  {
    id: "social-media-5",
    icon: "/assets/icons/linkedin.svg",
    link: "https://www.linkedin.com/company/fipay-io/about/?viewAsMember=true",
  },
];

export const NavIcon: NavIconSection[] = [
  {
    id: "client-1",
    name: "Anti-Fraud",
    // icon: airbnb,
    icon: "/assets/icons/anti-fraud.png",
    link: "https://www.twitter.com/",
  },
  {
    id: "client-2",
    name: "Billing",
    icon: "/assets/icons/bill.png",
    link: "https://www.twitter.com/",
  },
  {
    id: "client-3",
    name: "Card Acquiring",
    icon: "/assets/icons/card.png",
    link: "https://www.twitter.com/",
  },
  {
    id: "client-4",
    name: "Checkout",
    icon: "/assets/icons/shopping-cart.png",
    link: "https://www.twitter.com/",
  },
  {
    id: "client-5",
    name: "Cross-Border",
    icon: "/assets/icons/anti-fraud.png",
    link: "https://www.twitter.com/",
  },
  {
    id: "client-6",
    name: "Digital Wallet",
    icon: "/assets/icons/empty-wallet.png",
    link: "https://www.twitter.com/",
  },
  // {
  //   id: "client-7",
  //   name: "Identity Verification",
  //   icon: "/assets/icons/card.png",
  //   link: "https://www.twitter.com/",
  // },
  // {
  //   id: "client-8",
  //   name: "Insurance",
  //   icon: receipt,
  //   link: "https://www.twitter.com/",
  // },
  // {
  //   id: "client-9",
  //   name: "Checkout",
  //   icon: shopping,
  //   link: "https://www.twitter.com/",
  // },
  // {
  //   id: "client-10",
  //   name: "Invoicing",
  //   icon: note,
  //   link: "https://www.twitter.com/",
  // },
  // {
  //   id: "client-11",
  //   name: "Lending",
  //   icon: pos,
  //   link: "https://www.twitter.com/",
  // },
  // {
  //   id: "client-12",
  //   name: "Pay Later",
  //   icon: note,
  //   link: "https://www.twitter.com/",
  // },
  // {
  //   id: "client-13",
  //   name: "Payment Link",
  //   icon: pos,
  //   link: "https://www.twitter.com/",
  // },
  // {
  //   id: "client-14",
  //   name: "Peer-to-Peer",
  //   icon: p2p,
  //   link: "https://www.twitter.com/",
  // },
  // {
  //   id: "client-15",
  //   name: "P.O.S Payment",
  //   icon: pos,
  //   link: "https://www.twitter.com/",
  // },
  // {
  //   id: "client-16",
  //   name: "Payment Link",
  //   icon: "/assets/icons/card.png",
  //   link: "https://www.twitter.com/",
  // },
  // {
  //   id: "client-17",
  //   name: "Rewards",
  //   icon: gift,
  //   link: "https://www.twitter.com/",
  // },

  // {
  //   id: "client-18",
  //   name: "Tax Automation",
  //   icon: receipt,
  //   link: "https://www.twitter.com/",
  // },
  // {
  //   id: "client-19",
  //   name: "Ticketing",
  //   icon: ticket,
  //   link: "https://www.twitter.com/",
  // },
  // {
  //   id: "client-20",
  //   name: "Travels",
  //   icon: airplane,
  //   link: "https://www.twitter.com/",
  // },
];

export const productDropDownData: ProductDropDownData[] = [
  // {
  //   id: "product-1",
  //   label: "Anti-Fraud",
  //   icon: antiFraud,
  // },
  // {
  //   id: "product-2",
  //   label: "Billing",
  //   icon: bill,
  // },
  // {
  //   id: "product-3",
  //   label: "Card Acquiring",
  //   icon: "/assets/icons/card.png",
  // },
  // {
  //   id: "product-4",
  //   label: "Checkout",
  //   icon: shopping,
  // },
  // {
  //   id: "product-5",
  //   label: "Cross Border",
  //   icon: antiFraud,
  // },
  // {
  //   id: "product-6",
  //   label: "Digital Wallet",
  //   icon: "/assets/svg/digitalWalletId.svg",
  // },
  // {
  //   id: "product-7",
  //   label: "Identity Verification",
  //   icon: "/assets/icons/card.png",
  // },
  // {
  //   id: "product-8",
  //   label: "Insurance",
  //   icon: antiFraud,
  // },
  {
    id: "product-9",
    label: "Invoicing",
    icon: "/assets/icons/note.png",
  },
  // {
  //   id: "product-10",
  //   label: "Lending",
  //   icon: antiFraud,
  // },
  // {
  //   id: "product-11",
  //   label: "Pay Later",
  //   icon: antiFraud,
  // },
  {
    id: "product-12",
    label: "Payment Link",
    icon: "/assets/svg/link.svg",
  },
  // {
  //   id: "product-13",
  //   label: "Peer-to-Peer",
  //   icon: gift
  // },
  // {
  //   id: "product-14",
  //   label: "P.O.S Payment",
  //   icon: antiFraud,
  // },
  // {
  //   id: "product-15",
  //   label: "Reporting",
  //   icon: antiFraud,
  // },
  // {
  //   id: "product-16",
  //   label: "Rewards",
  //   icon: gift,
  // },
  {
    id: "product-17",
    label: "Services",
    icon: "/assets/icons/card.png",
  },
  // {
  //   id: "product-18",
  //   label: "Tax Automation",
  //   icon: receipt,
  // },
  // {
  //   id: "product-19",
  //   label: "Ticketing",
  //   icon: ticket,
  // },
  // {
  //   id: "product-20",
  //   label: "Travels",
  //   icon: airplane,
  // },
];
